"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areDuplicatesExist = exports.updateUniqueItemListBasedOnValueAndProp = exports.updateUniqueItemListBasedOnValue = exports.getTreeNodeIdFromPath = void 0;
const ramda_1 = require("ramda");
const store_1 = require("../../store");
const getTreeNodeIdFromPath = (treePath) => treePath === null || treePath === void 0 ? void 0 : treePath.split(store_1.STRATEGY_NODE_PATH_SEPARATOR).pop();
exports.getTreeNodeIdFromPath = getTreeNodeIdFromPath;
const updateUniqueItemListBasedOnValue = (items, value) => (list) => {
    const newItems = Array.isArray(items) ? items : [items];
    const newList = new Set(value ? [...list, ...newItems] : (0, ramda_1.without)(newItems, list));
    return Array.from(newList);
};
exports.updateUniqueItemListBasedOnValue = updateUniqueItemListBasedOnValue;
const updateUniqueItemListBasedOnValueAndProp = (item, value, propName) => (list) => {
    const key = item[propName];
    const selectedItem = list.findIndex((listItem) => listItem[propName] === key);
    if (selectedItem >= 0 && !value) {
        return list.filter((listItem) => listItem[propName] !== key);
    }
    if (selectedItem < 0 && value) {
        return [...list, item];
    }
    return list;
};
exports.updateUniqueItemListBasedOnValueAndProp = updateUniqueItemListBasedOnValueAndProp;
const areDuplicatesExist = ({ list, propName, useLowerCase = true }) => {
    const uniqueValues = new Set(list.map((item) => (useLowerCase ? String(item[propName]).toLowerCase() : String(item[propName]))));
    return uniqueValues.size < list.length;
};
exports.areDuplicatesExist = areDuplicatesExist;
